var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChannelName } from '../../../learnware/LearnwareEnums';
import { ChannelVoice } from '../mediaChannel/modules/ChannelVoice';
import { ChannelSound } from '../mediaChannel/modules/ChannelSound';
import { ChannelBackground } from '../mediaChannel/modules/ChannelBackground';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
export class PlayerChannels {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get mediaPlayer() {
        return this.parent;
    }
    get intents() {
        return this.mediaPlayer.intents;
    }
    channelVoice = new ChannelVoice(this);
    channelSound = new ChannelSound(this);
    channelBackground = new ChannelBackground(this);
    get channelList() {
        return [this.channelVoice, this.channelSound, this.channelBackground];
    }
    getChannel(channel) {
        if (channel === ChannelName.Sound)
            return this.channelSound;
        if (channel === ChannelName.Background)
            return this.channelBackground;
        return this.channelVoice;
    }
}
__decorate([
    memoize
], PlayerChannels.prototype, "channelList", null);
